/**
 * Utility class to build query strings supporting arrays of values.
 */
var QueryBuilder = /** @class */ (function () {
    function QueryBuilder(query) {
        this.query = new URLSearchParams(query);
    }
    /**
     * Adds the given value or array of values to the query.
     * If no value is provided the query string is not modified.
     *
     * @param {String} key Query string parameter name.
     * @param {*} values Zero, one, or an array of values to add to the query string.
     * @param {Object} options (Optional) Options to customize the value serialization.
     *   @param {Boolean} options.isDate True to format the value as an ISO 8601 date.
     *   @param {Boolean} options.clearPrior True to remove any prior value before adding.
     */
    QueryBuilder.prototype.add = function (key, values, _a) {
        var _b = _a === void 0 ? {} : _a, isDate = _b.isDate, clearPrior = _b.clearPrior;
        for (var _i = 0, _c = Array.isArray(values) ? values : [values]; _i < _c.length; _i++) {
            var value = _c[_i];
            if (value === undefined) {
                continue;
            }
            if (isDate) {
                value = value.toISOString();
            }
            if (clearPrior) {
                // This pattern makes param ordering stable in the URL regardless of the order set
                this.query.set(key, value);
                clearPrior = false;
            }
            else {
                this.query.append(key, value);
            }
        }
        return this;
    };
    QueryBuilder.prototype.set = function (key, values) {
        if (values === null || (Array.isArray(values) && values.length === 0)) {
            this.remove(key);
        }
        else {
            this.add(key, values, { clearPrior: true });
        }
        return this;
    };
    /**
     * Sets multiple properties from the provided object.
     * @param {Object} params Object containing the properties to set. Inherited
     *   and undefined properties are ignored.
     */
    QueryBuilder.prototype.setMany = function (params) {
        for (var _i = 0, _a = Object.entries(params !== null && params !== void 0 ? params : {}); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (value !== undefined) {
                if (value === null) {
                    this.remove(key);
                }
                else {
                    this.set(key, value);
                }
            }
        }
        return this;
    };
    QueryBuilder.prototype.remove = function (key) {
        this.query.delete(key);
        return this;
    };
    QueryBuilder.prototype.get = function (name) {
        return this.query.get(name);
    };
    QueryBuilder.prototype.getAll = function (name) {
        return this.query.getAll(name);
    };
    QueryBuilder.prototype.toString = function () {
        var queryString = this.query.toString();
        // If not empty, return the query string with ? prefixed
        return queryString ? "?".concat(queryString) : "";
    };
    return QueryBuilder;
}());
export { QueryBuilder };
